import React from 'react';
import { Field } from 'react-final-form';

import CheckboxInput from '../utils/CheckboxInput';

const CheckboxField = React.memo( ( {
  field, validate, value, name, ...rest
} ) => {
  if ( field ) {
    return (
      <Field name={field} validate={validate}>
        {( { meta, input } ) => {
          const isInvalid = ( meta.touched && meta.error )
            || ( meta.touched && !meta.dirtySinceLastSubmit && meta.submitError );

          return (
            <CheckboxInput
              {...input}
              {...rest}
              value={input.value || ''}
              inputOnChange={input.onChange}
              inputName={input.name}
              focused={meta.active}
              meta={meta}
              isInvalid={isInvalid}
            />
          );
        }}
      </Field>
    );
  }
  return (
    <CheckboxInput
      {...rest}
      value={value || ''}
      inputName={name}
    />
  );
} );

export default CheckboxField;
